import React, { useEffect, useState } from "react";
import Layout from "../Home";
import { connect, useDispatch} from "react-redux";
import { getCategory } from "../../action/menuActions";
import { getCatProducts } from "../../action/productsAction";
import appConfig from "../../helpers/appConfig";
import "./style.css";
import { Col, Button, Row } from "antd";
import { socket } from "../../utils/socketNew";
import { getOnlineOrders, getOnlineTableBookingCount, getOrderCount } from "../../action/ordersAction";
import { playSound } from "../../helpers/socket";
const Dashboard = (props) => {
  const dispatch = useDispatch();
  let [pId, setPid] = useState("");
  let [page, setPage] = useState("cat");
  let [catName, setCatName] = useState("");
  useEffect(() => {
    if (localStorage.getItem("token")) {
    
       props.getCategory();
    
      

    }
  }, []);
  useEffect(() => {
    if (pId) {
      props.getCatProducts(pId);
    }
  }, [pId]);
  const handleChange = (id, name) => {
    setPid(id);
    setPage("pro");
    setCatName(name);
  };
  const IconsGridCat = () => {
    const { categories } = props;
    return (
      categories &&
      categories.map((category) => {
        let icon = category.thumbnail
          ? `${appConfig.s3url}/${category.thumbnail}`
          : `${appConfig.s3url}/${category.image}`;
        return (
          <Col key={category._id} className="items gutter-row">
            <div className="button-style font">
              <Button
                className="button-size-icon"
                onClick={() => handleChange(category._id, category.name)}
              >
                <div className="menu-options white">
                  <img src={icon} className="product-image" />
                </div>
                <div className="menu-options details">
                  <span className="menu-options price">{category.name}</span>
                </div>
              </Button>
            </div>
          </Col>
        );
      })
    );
  };
  const IconsGridProd = () => {
    const { products } = props;
    const proArry = products.data;
    return (
      proArry &&
      proArry.map((product) => {
        let icon = product.thumbnail
          ? `${appConfig.s3url}/${product.thumbnail}`
          : `${appConfig.s3url}/${product.image}`;
        return (
          <Col key={product._id} className="items gutter-row">
            <div className="button-style">
              <Button className="button-size-icon">
                <div className="menu-options white">
                  <img src={icon} className="product-image" />
                </div>
                <span className="menu-options name">kr.{product.price}</span>
                <div className="menu-options details">
                  <span className="menu-options price">{product.name}</span>
                </div>
              </Button>
            </div>
          </Col>
        );
      })
    );
  };
  const backBtn = () => {
    if (page === "pro") {
      return (
        <Button className="back-btn" onClick={() => setPage("cat")}>
          <i
            className="fa fa-arrow-circle-left"
            style={{ fontSize: 20, marginTop: 1 }}
            aria-hidden="true"
          />
        </Button>
      );
    }
  };
  return (
    <Layout>
      <div className="report-container text-center">
        <span className="item">
          <span>Hjem / </span>
          {page === "cat" ? "Kategori" : `Produkt: ${catName}`}
        </span>
        {backBtn()}
      </div>
      <Row className="dashboard-flex" type="flex" align="middle" gutter={0}>
        {page === "cat" ? IconsGridCat() : IconsGridProd()}
      </Row>
    </Layout>
  );
};

const mapStateToProps = ({ categories, products }) => {
  return {
    categories,
    products,
  };
};
export default connect(mapStateToProps, { getCategory, getCatProducts })(
  Dashboard
);
